import React, { Component, Fragment } from "react";

import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import * as common from "../../lib/common"
import { storedb } from '../../views/client/storedb'
import AppConfig from '../../config/app'

import * as orderActions from './actions'
import orderConstants, { FormFiels } from './constants'
import OrderControls from './OrderControls'

class Order extends Component {
  constructor(props) {
    super(props);
    let dbContext = storedb()
    this.state = {
      quantity: 1,
      is_km: 0,
      dvt: '',
      dvt_id: 0,
      item_id: '',
      product_id: 0,
      productCtl: {},
      hasChanged: false,
      storeId: dbContext.getStoreId(),
      showCkPercent: dbContext.getSettingValue(AppConfig.SETTINGKEYS.ShowCkPercent, "0"),
      productPrices: [],
      productPriceSelect: 0,
      discountProductSelect: 0,
      listDiscountOrder: dbContext.getSettingValue(AppConfig.SETTINGKEYS.ListDiscountOrder, "0"),
    }
    dbContext = storedb()
  }

  checkTypeOrder = (callback) => {
    const params = this.props.match ? this.props.match.params : {};
    if (params) {
      const { type, id } = params;
      this.props.setTypeOrder(+type)
      const mode = (id && id != '') ? orderConstants.MODE.IN_EDIT : orderConstants.MODE.IN_CREATE

      this.props.setMode(mode)
      this.props.setOrderId(id)

      callback(mode)
    }
  }

  return2List = () => {
    if (this.props.mode === orderConstants.MODE.IN_EDIT) {
      // neu o mode sua don can unlock don hang khi bam nut back
      const payload = {
        orderId: this.props.orderId,
        typeOfOrder: this.props.typeOfOrder
      }
      this.props.unlockOrder(payload, () => {
        this.gotoView()
      })
    } else {
      this.gotoList()
    }
  }
  gotoList = () => {
    const type = this.props.typeOfOrder || constants.default.TYPEOF_ORDER.FOR_DEFAULT;
    const url = `/orders/${type}`
    this.props.history.push(url)
  }
  gotoView = (data) => {
    // trở lại trang view
    const type = this.props.typeOfOrder || constants.default.TYPEOF_ORDER.FOR_DEFAULT;
    const orderId = data ? data.Id : this.props.orderId
    const url = `/order-view/${type}/${orderId}`
    this.props.history.push(url);
  }
  onHandleClick = (usersChecked, isForceLoad) => {
    let userId = 0, tenUser = ''
    if (usersChecked && usersChecked.length > 0) {
      userId = usersChecked[0].value || 0
      tenUser = usersChecked[0].label
      this.props.setUsersChecked(usersChecked);
    } else {
      this.props.setUsersChecked([]);
    }
    this.updateInfor(FormFiels.NhanVienId, userId)
    this.updateInfor(FormFiels.TenNhanVien, tenUser)

    if (isForceLoad) {
      this.loadDataForNhanVien()
    }
  }
  onHandleRemove = (nodeChecked) => {
    let usersChecked = this.props.usersChecked;
    var index = usersChecked.findIndex(e => e.value == nodeChecked.value);
    if (index > -1) {
      usersChecked.splice(index, 1);
    }

    this.onHandleClick(usersChecked)
    this.loadDataForNhanVien()
  }
  onHandleChoice = (usersChecked) => {
    this.onHandleClick(usersChecked)
    this.loadDataForNhanVien()
  }
  loadDataForNhanVien = () => {
    // xoa thong tin khach hang vua chon khi cho nhan ven khac
    this.resetCustomer()
    const formData = {
      storeId: this.state.storeId,
      userId: this.props.orderInfor[FormFiels.NhanVienId],
      typeOfOrder: this.props.typeOfOrder
    }
    this.props.loadCustomers(formData, (items) => {
      if (items && items.length === 1) {
        // neu chi co 1 khach hang thi hỗ trợ chọn luôn
        this.onCustomerSelectChanged({ value: items[0].Id })
      }
    });
    this.props.loadKhos(formData, (items) => {
      let khoXuatId = 0, tenKhoXuat = ''
      if (items && items.length === 1) {
        khoXuatId = items[0]["Id"]
        tenKhoXuat = items[0]["Ten"]
      }
      this.updateInfor(FormFiels.KhoXuatId, khoXuatId)
      this.updateInfor(FormFiels.TenKhoXuat, tenKhoXuat)
    });
  }
  onCustomerSelectChanged = (selectedOption) => {
    const formData = {
      khach_hang_id: selectedOption.value,
      store_id: this.state.storeId,
      typeOfOrder: this.props.typeOfOrder
    }

    this.props.loadCustomer(formData, this.calcOrder)
    this.updateInfor(FormFiels.KhachHangId, formData.khach_hang_id)
    this.updateInfor(FormFiels.KhoNhapId, formData.khach_hang_id)
  }

  formatOptionLabel = (option) => {
    return (
      <div className="item">
        <div>{option.label}</div>
        <span className={"item_unit"}>{'\u00A0'}{option.diaChi}</span>
      </div>
    )
  }

  formatNoOptionLabel = (input) => {
    return (
      <Fragment>
        <em>Không tìm khách hàng <i className="text-danger">#{input}</i></em>
      </Fragment>
    )
  }

  productHandleSelectChange = (selectedOption) => {
    const khoXuatId = this.props.orderInfor[FormFiels.KhoXuatId]
    if (!khoXuatId || khoXuatId === ''
      || isNaN(khoXuatId) || (+khoXuatId) <= 0) {
      this.props.setWarning('Chưa chọn kho xuất')
      this.state.productCtl.handleClearClick()
      return false
    }
    this.props.loadProductPrice({ ProductId: selectedOption.value }, (listPrice) => {
      this.setState({
        dvt: selectedOption.dvt,
        product_id: selectedOption.value,
        productPrices: listPrice
      }, () => {
        this.props.setFlagAddItem(true)
      })
    })
  }
  thuocFormatOptionLabel = (option) => {
    let classPlus = ""
    if (option.quantity <= 0) {
      classPlus = "item_unit_0"
    } else if (option.quantity <= 100) {
      classPlus = "item_unit_100"
    }

    return (
      <div className="item">
        {'\u00A0'}{'\u00A0'}
        {option.label}
        {/* <span className={`item_unit ${classPlus}`}>{'\u00A0'}({option.quantity || 0} {option.dvt})</span> */}
        <span className={`item_unit ${classPlus}`}>{'\u00A0'}</span>
      </div>
    )
  }

  thuocFormatNoOptionLabel = (input) => {
    return (
      <Fragment>
        <em>Không tìm thấy sản phẩm <i className="text-danger">#{input}</i></em>
      </Fragment>
    )
  }
  thuocHandleChanged = (keyword, callback) => {
    const khoXuatId = this.props.orderInfor[FormFiels.KhoXuatId]
    this.props.loadThuocs({
      store_id: this.state.storeId,
      kho_id: khoXuatId,
      keyword: keyword
    }, (data) => {
      if (callback) {
        callback()
      }
    });
  }
  thuocHandleClearClick = e => {
    this.props.setFlagAddItem(false)
    this.props.setThuoc()
  }
  setProductCtl = (e) => {
    this.setState({ productCtl: e });
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  handleAddItem = () => {
    if (!this.props.enabledAddItem) {
      return false
    }
    const khoXuatId = this.props.orderInfor[FormFiels.KhoXuatId]
    if (!khoXuatId || khoXuatId === ''
      || isNaN(khoXuatId) || (+khoXuatId) <= 0) {
      this.props.setWarning('Chưa chọn kho xuất')
      return false
    }
    const { quantity, item_id, product_id, is_km } = this.state
    if (!product_id || product_id <= 0) {
      this.props.setWarning('Chưa chọn sản phẩm')
      return false;
    }
    if (quantity <= 0) {
      this.props.setWarning('Số lượng phải >= 1')
      return false;
    }

    const formData = {
      item_id: item_id,
      product_id: product_id,
      so_luong: quantity,
      kho_id: khoXuatId,
      is_km: is_km,
      gia_ban: this.state.productPriceSelect,
      CkPercent: this.state.discountProductSelect
    }

    const loadSuccess = (data) => {
      this.calcOrder()
      this.resetFormItem()
      this.props.setFlagAddItem(false)
    }
    this.props.setWarning('')
    this.props.loadThuoc(formData, loadSuccess)
  }
  handleEditItem = (item) => {
    this.state.productCtl.setValueBox(item.ten)
    this.setState({
      quantity: item.so_luong,
      item_id: item.id,
      is_km: item.is_km,
      product_id: item.product_id,
    })
    this.props.loadProductPrice({ ProductId: item.product_id }, (prices) => {
      this.setState({ productPrices: prices, productPriceSelect: item.gia_ban_origin })
      this.props.setFlagAddItem(true)
    })
  }
  handleRemoveItem = (item) => {
    let items = this.props.items
    const existed = items.findIndex(x => x.product_id === item.product_id)
    if (existed >= 0) {
      items.splice(existed, 1)
      this.props.setItems(items)
      this.resetFormItem()
      this.setState({ hasChanged: true })
      // neu la sua don thi can canh bao de nguoi dung luu lại
      if (this.props.mode == orderConstants.MODE.IN_EDIT) {
        this.props.setWarning('Chú ý hành động chỉ xoá tạm thời, cần nhấn [Lưu] để hoàn tất')
      }
    }
  }

  resetFormItem = () => {
    this.props.setFlagAddItem(false)
    this.props.setThuoc()
    this.props.setOrderTotal(null)
    this.state.productCtl.handleClearClick()
    this.setState({
      quantity: 1,
      is_km: 0,
      item_id: '',
      product_id: 0,
      dvt: '',
      dvt_id: 0,
      hasChanged: true,
      productPrices: [],
      productPriceSelect: 0,
      discountProductSelect: 0
    })
  }
  downQuantityClick = () => {
    const { quantity } = this.state
    if (quantity === 1) {
      return
    }
    this.setState({ quantity: quantity - 1 })
    this.props.setWarning('')
  }
  upQuantityClick = () => {
    const { quantity } = this.state
    this.setState({ quantity: quantity + 1 })
    this.props.setWarning('')
  }
  handleQuantityChange = (e) => {
    let quantity = ''
    if (e && e.value && !isNaN(e.value)) {
      quantity = +e.value
    }
    if (quantity < 1) {
      quantity = 1
    }
    this.setState({ quantity: quantity })
    this.props.setWarning('')
  }
  handleIsKMChange = (isChecked) => {
    this.setState({ is_km: isChecked ? 1 : 0 })
  }
  handleQuantityKeyPress = (e) => {
    // neu enter thi goi vao nut add item
    if (e.keyCode == 13) {
      this.handleAddItem()
    }
  }
  handleDateCreated = (e) => {
    this.updateInfor(FormFiels.NgayLap, e)
  }
  handleNoteCreated = ({ target }) => {
    this.updateInfor(FormFiels.GhiChu, target.value)
  }

  handleBoCkCreated = ({ target }) => {
    this.updateInfor(FormFiels.BoChietKhau, target.checked)
    this.calcOrder()
  }

  handleXuatHDCreated = ({ target }) => {
    this.updateInfor(FormFiels.XuatHoaDon, target.checked)
  }

  handleKhoChange = ({ target }) => {
    const khoId = target.value || 0
    const kho = this.getKho(khoId)
    this.updateInfor(FormFiels.KhoXuatId, khoId)
    this.updateInfor(FormFiels.TenKhoXuat, kho.Ten)
    this.props.setWarning('')
  }
  getKho = (khoId) => {
    const kho = this.props.khoXuats.find(x => x.Id == khoId)
    return kho || {}
  }
  updateInfor = (key, value) => {
    const { hasChanged } = this.state
    let orderInfor = this.props.orderInfor
    orderInfor[key] = value
    this.props.setOrderInfor(orderInfor)
    this.setState({ hasChanged: !hasChanged })
  }
  validForm = () => {
    const orderInfor = this.props.orderInfor
    const items = this.props.items || []
    const sumFee = common.sum(items, "thanh_tien")
    if (!orderInfor[FormFiels.NhanVienId] || orderInfor[FormFiels.NhanVienId] === '') {
      this.props.setError("Chưa chọn nhân viên")
      return false
    }
    if (!orderInfor[FormFiels.KhoXuatId] || orderInfor[FormFiels.KhoXuatId] === '') {
      this.props.setError("Chưa chọn kho xuất")
      return false
    }
    if (!orderInfor[FormFiels.KhachHangId] || orderInfor[FormFiels.KhachHangId] === '') {
      this.props.setError("Chưa chọn khách hàng")
      return false
    }
    if (sumFee < 0) {
      this.props.setError("Tổng tiền đơn hàng phải >=0")
      return false
    }
    return true

  }
  saveOrder = e => {
    if (!this.validForm()) return false
    const callback = (data) => {
      setTimeout(e => {
        this.resetForm()
        this.gotoView(data)
      }, 1500)
    }
    this.props.saveOrder(callback)
  }
  calcOrder = e => {
    const hasItems = this.props.items && this.props.items.length > 0
    if (!hasItems) {
      return
    }
    this.props.calcOrder((responseData) => {
      if (!responseData) return
      let items = this.props.items
      let orderTotal = this.props.orderTotal
      items = this.props.items.map((item) => {
        const itemCt = responseData.find(x => x.product_id === item.product_id && x.is_km == item.is_km)
        if (itemCt) {
          item[FormFiels.Diem] = itemCt[FormFiels.Diem] || 0
          item[FormFiels.ChietKhau] = itemCt[FormFiels.ChietKhau]
          item[FormFiels.ThanhTien] = itemCt[FormFiels.ThanhTien]
        }
        return item
      })
      this.props.setItems(items)
      this.props.setOrderTotal(orderTotal)
      this.setState({ hasChanged: true })
    })
  }
  resetForm = e => {
    this.props.resetForm()
  }
  resetCustomer = () => {
    // reset thong tin khach hang tren form
    this.updateInfor(FormFiels.KhachHangId, null)
    this.updateInfor(FormFiels.MaKhachHang, '')
    this.updateInfor(FormFiels.TenKhachHang, '')
    this.updateInfor(FormFiels.DiaChi, '')
    this.updateInfor(FormFiels.DienThoai, '')
    this.updateInfor(FormFiels.MaSoThue, '')
    this.updateInfor(FormFiels.HdThamGia, '')
  }
  showDialogLockPushOrder = (msg) => {
    msg = msg || 'Hiện tại hệ thống đang khoá chức năng đặt đơn'
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>{msg}</p>
            <button className="text-danger" onClick={() => {
              this.return2List()
              onClose()
            }}>Quay về</button>
          </div>
        )
      }
    })
  }
  checkCanPushOrder = (mode) => {
    // kiem tra xem co cho dat don hay khong
    const requestForm = {
      store_id: this.state.storeId
    }
    this.props.canPushOrder(requestForm, (responseData) => {
      if (responseData && responseData === true) {
        this.prepareOrder(mode)
      } else {
        this.showDialogLockPushOrder()
      }
    })
  }
  prepareOrder = (mode) => {
    if (mode === orderConstants.MODE.IN_EDIT) {
      const payload = {
        orderId: this.props.orderId,
        mode
      }
      const callback = {
        onSuccess: (data) => {

        },
        onError: (message) => {
          this.showDialogLockPushOrder(message)
        }
      }
      this.props.getOrderDetails(payload, callback)
    } else {
      this.props.loadUsers({
        store_id: this.state.storeId,
        is_only_inherit: false,
      }, (users) => {
        // xu ly logic khi load users xong tu server
        if (users && users.length === 1) {
          // neu chi co 1 minh no thì thực hiện set luôn user đó
          const usersChecked = users.map((item) => {
            return { value: item.Id, label: `${item.Name}/ ${item.SubName}` }
          })
          this.onHandleClick(usersChecked, true)
        }
      });
      this.props.loadThuocs({
        store_id: this.state.storeId,
        keyword: ''
      });
    }
  }
  handleProductPriceSelectChange = (name, selectedOption) => {
    switch (name) {
      case "ProductPrice":
        this.setState({ productPriceSelect: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  handleDiscountOrderSelectChange = (name, selectedOption) => {
    switch (name) {
      case "DiscountOrder":
        this.setState({ discountProductSelect: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  componentWillMount() {
    const checkTypeCallback = (mode) => {
      this.checkCanPushOrder(mode)
    }
    this.checkTypeOrder(checkTypeCallback)
  }
  componentWillUnmount() {
    this.resetForm()
  }
  componentDidMount() {
    this.props.setOrderTotal(null)
  }
  render() {
    return (
      <div className="animated fadeIn order">
        <OrderControls
          requesting={this.props.requesting}
          warnings={this.props.warnings}
          messages={this.props.messages}
          errors={this.props.errors}
          mode={this.props.mode}
          orderId={this.props.orderId}
          orderInfor={this.props.orderInfor}
          customerInfor={this.props.customerInfor}
          customers={this.props.customers}
          khoXuats={this.props.khoXuats}
          thuocs={this.props.thuocs}
          users={this.props.users}
          productPrices={this.state.productPrices}
          usersChecked={this.props.usersChecked}
          enabledAddItem={this.props.enabledAddItem}
          items={this.props.items}
          isShowCKPercent={this.state.showCkPercent === "1"}
          quantity={this.state.quantity}
          isKM={this.state.is_km == 1}
          typeOfOrder={this.props.typeOfOrder}
          orderTotal={this.props.orderTotal}
          productPriceSelect={this.state.productPriceSelect}
          listDiscountOrder={this.state.listDiscountOrder != '0' ? this.state.listDiscountOrder.split(',') : [0]}
          discountProductSelect={this.state.discountProductSelect}
          handleKhoChange={this.handleKhoChange}
          onHandleClick={this.onHandleClick}
          onHandleRemove={this.onHandleRemove}
          onHandleChoice={this.onHandleChoice}
          formatOptionLabel={this.formatOptionLabel}
          formatNoOptionLabel={this.formatNoOptionLabel}
          onCustomerSelectChanged={this.onCustomerSelectChanged}
          handleDateCreated={this.handleDateCreated}
          thuocFormatOptionLabel={this.thuocFormatOptionLabel}
          thuocFormatNoOptionLabel={this.thuocFormatNoOptionLabel}
          thuocHandleClearClick={this.thuocHandleClearClick}
          thuocHandleChanged={this.thuocHandleChanged}
          productHandleSelectChange={this.productHandleSelectChange}
          setProductCtl={this.setProductCtl}
          numberOnclick={this.numberOnclick}
          handleQuantityChange={this.handleQuantityChange}
          handleIsKMChange={this.handleIsKMChange}
          upQuantityClick={this.upQuantityClick}
          downQuantityClick={this.downQuantityClick}
          handleQuantityKeyPress={this.handleQuantityKeyPress}
          handleAddItem={this.handleAddItem}
          handleEditItem={this.handleEditItem}
          handleRemoveItem={this.handleRemoveItem}
          save={this.saveOrder}
          return2List={this.return2List}
          handleNoteCreated={this.handleNoteCreated}
          handleBoCkCreated={this.handleBoCkCreated}
          handleXuatHDCreated={this.handleXuatHDCreated}
          handleProductPriceSelectChange={this.handleProductPriceSelectChange}
          handleDiscountOrderSelectChange={this.handleDiscountOrderSelectChange}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  users: state.order.users,
  usersChecked: state.order.usersChecked,
  customers: state.order.customers,
  customerInfor: state.order.customerInfor,
  orderInfor: state.order.orderInfor,
  thuocs: state.order.thuocs,
  thuocInfor: state.order.thuocInfor,
  errors: state.order.errors,
  messages: state.order.messages,
  warnings: state.order.warnings,
  requesting: state.order.requesting,
  enabledAddItem: state.order.enabledAddItem,
  items: state.order.items,
  khoXuats: state.order.khoXuats,
  typeOfOrder: state.order.typeOfOrder,
  mode: state.order.mode,
  orderId: state.order.orderId,
  orderTotal: state.order.orderTotal
})

const connected = connect(mapStateToProps,
  {
    setUsersChecked: orderActions.setUsersChecked,
    loadCustomer: orderActions.loadCustomer,
    loadCustomers: orderActions.loadCustomers,
    loadThuoc: orderActions.loadThuoc,
    loadProductPrice: orderActions.loadProductPrice,
    loadThuocs: orderActions.loadThuocs,
    loadUsers: orderActions.loadUsers,
    loadKhos: orderActions.loadKhos,
    setFlagAddItem: orderActions.setFlagAddItem,
    setIsLoading: orderActions.setIsLoading,
    setWarning: orderActions.setWarning,
    setError: orderActions.setError,
    setItems: orderActions.setItems,
    setOrderInfor: orderActions.setOrderInfor,
    saveOrder: orderActions.saveOrder,
    setTypeOrder: orderActions.setTypeOrder,
    setThuoc: orderActions.setThuoc,
    setProductPrice: orderActions.setProductPrice,
    resetForm: orderActions.resetForm,
    setMode: orderActions.setMode,
    setOrderId: orderActions.setOrderId,
    getOrderDetails: orderActions.getOrderDetails,
    setCallbackFunc: orderActions.setCallbackFunc,
    unlockOrder: orderActions.unlockOrder,
    calcOrder: orderActions.calcOrder,
    canPushOrder: orderActions.canPushOrder,
    setOrderTotal: orderActions.setOrderTotal
  })(Order)

const formed = reduxForm({
  form: 'order',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Order/Order.js